import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutMovement, WorkoutMovementWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateWorkoutBenchmark(): UseMutationResult<
  AxiosResponse<WorkoutMovement>,
  AxiosError<ErrorMessage>,
  WorkoutMovementWrite
> {
  const queryClient = useQueryClient();

  const createWorkoutBenchmark = (
    benchmark: WorkoutMovementWrite,
  ): Promise<AxiosResponse<WorkoutMovement>> => {
    return client.post('workout-movements/', benchmark);
  };

  return useMutation(createWorkoutBenchmark, {
    onSuccess: () => {
      queryClient.invalidateQueries('workoutBenchmarks');
    },
  });
}
